import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HttpService } from '../shared/services/http.service';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';

@Component({
    selector: 'app-csm-report',
    templateUrl: './csm-report.component.html',
    styleUrls: ['./csm-report.component.scss'],
    standalone: false
})
export class CsmReportComponent implements OnInit {


  @Input() code
  @Input() codeDescription
  @Input() clientName

  @Output() close: EventEmitter<Boolean> = new EventEmitter<Boolean>();

  academicYears = []
  academicYearFilter = null
  questions = []
  
  displayedColumns = [ 'select', 'value']
  dataSource: MatTableDataSource<any>
  selection = new SelectionModel<any>(true, []);

  loading = true

  constructor(private httpService: HttpService) { }

  async ngOnInit() {
    this.dataSource = new MatTableDataSource([]);
    await this.fetchAcademicYears()
    await this.fetchQuestions()
  }

  async fetchAcademicYears(){
    const res:any = await this.httpService.postAsync("report/academicYears", {})

    this.academicYears = res.academicYears
  }

  async fetchQuestions(){
    this.loading = true
    const res:any = await this.httpService.postAsync("report/getCsmQuestions", {code: this.code})
    
    if( res.success ){
        this.dataSource.data = res.data.map( q => ({ value: q }))
        // select all by default
        this.dataSource.data.forEach(row => this.selection.select(row));
    }
    this.loading = false
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected() ?
        this.selection.clear() :
        this.dataSource.data.forEach(row => this.selection.select(row));
  }

  cancel(){
    this.close.emit(false)
  }

  async download( ){

    const questions = this.selection.selected.map( q => q.value )

    const responseData:any = await this.httpService.getText("report/csm", {code: this.code, academicYear : this.academicYearFilter, questions: questions})

    const blob = new Blob([responseData], { type: 'text/html' }); // Use the correct MIME type

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `CSM-${this.code}-${this.codeDescription}.html`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    this.close.emit(false)
    return false


  }

  async downloadExcel( ){

    const questions = this.selection.selected.map( q => q.value )

    const responseData:any = await this.httpService.postBlob("report/csmexcel", {code: this.code, academicYear : this.academicYearFilter, questions: questions})

    const blob = new Blob([responseData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `CSM-${this.code}-${this.codeDescription}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    this.close.emit(false)
    return false

  }


  selectAcademicYear(event) {

    const year = event.target.value

    this.academicYearFilter = this.academicYears.find( yearObject => yearObject.formatted_year == year )

  }

}
